import React from "react";
import { Box } from "../../UI/Box";
import { Typography } from "../../UI/Typography";
import { useRightPopupContext } from "./context";


export const GroupFilter: React.FC = () => {
  const { showOnlyRenewing, setShowOnlyRenewing } = useRightPopupContext();

  const handleShowAllGroups = () => {
    setShowOnlyRenewing(false);
  };

  const handleShowOnlyRenewing = () => {
    setShowOnlyRenewing(true);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center">
        <img
          src="/static/images/icons/filter.png"
          alt="Filter"
          style={{
            width: '16px',
            height: '16px',
            marginRight: '8px'
          }}
        />
        <Typography
          variant="body2"
          component="span"
          onClick={handleShowAllGroups}
          fontWeight={!showOnlyRenewing ? 700 : 400}
          sx={{
            mr: 2,
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Show all groups
        </Typography>
        <Typography
          variant="body2"
          component="span"
          onClick={handleShowOnlyRenewing}
          fontWeight={showOnlyRenewing ? 700 : 400}
          sx={{
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Show only groups with at least one renewal
        </Typography>
      </Box>
    </Box>
  );
};
